module.exports = __webpack_public_path__ + "static/media/material-edit.50678e52.svg";